import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { CompanyRoleEntity, ICompanyRoleEntity } from "@odata/GeneratedEntityTypes";
import { CompanyRolePermissionsPath } from "@pages/admin/companyRoles/CompanyRolesDef";
import { cloneDeep } from "lodash";

import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { FormViewForExtend } from "../../../views/formView/FormView";

class CompanyRolesFormView extends FormViewForExtend<ICompanyRoleEntity> {
    handleChange(e: ISmartFieldChange) {
        this.handleTypeChange(e);
        super.handleChange(e);
    }

    handleTypeChange = (e: ISmartFieldChange) => {
        if (e.bindingContext.getPath() === CompanyRoleEntity.Type) {
            const { storage } = this.props;
            storage.addActiveField(storage.data.bindingContext.navigate(CompanyRolePermissionsPath));
            storage.refreshFields();
        }
    };

    onBeforeSave(): ICompanyRoleEntity {
        const data = cloneDeep(this.entity);
        if (this.props.storage.data.bindingContext.isNew()) {
            data.CompanyRolePermissions = data.CompanyRolePermissions.filter(crp => crp.CompanyPermission.CompanyRoleTypeCode === this.entity.TypeCode);
        }
        return data;
    }
}

export default withPermissionContext(CompanyRolesFormView);